// THIS IS AN AUTO GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export const VERSION = '7.4.0';
export const VERSION_NUMBER = 704000000;
